/* eslint-disable indent */
import shortid from 'shortid';
import DADOS_SIM from './../../consts/consts';
import SessionService from './../../session/session-service';
import { extractErrorFromResponse } from '../../assets/js/function-utils';

const beneficiarioValues = DADOS_SIM.BENEFICIARIOS;

/**
 * Types
 */

export const beneficiariosTypes = {
    POPULATE_BENEFICIARIO: 'beneficiarios/POPULATE_BENEFICIARIO',
    ADICIONAR_BENEFICIARIO: 'beneficiarios/ADICIONAR_BENEFICIARIO',
    ATUALIZA_BENEFICIARIO: 'beneficiarios/ATUALIZA_BENEFICIARIO',
    EXCLUIR_BENEFICIARIO: 'beneficiarios/EXCLUIR_BENEFICIARIO',
    RESET: 'beneficiarios/RESET'
};

/**
 * Reducer
 */
let INITIAL_STATE = {
    [beneficiarioValues.THIS]: null
};

/**
 *
 * @param {Array<{id: number}>} listaBeneficiarios
 * @param {{id: number}} dadosBeneficiario
 */

function altualizaBeneficiario(listaBeneficiarios, dadosBeneficiario) {
    try {
        return listaBeneficiarios.map((item) => {
            if (item[beneficiarioValues.ID_BENEFICIARIO] !== dadosBeneficiario[beneficiarioValues.ID_BENEFICIARIO]) {
                return item;
            }
            return {
                ...item,
                ...dadosBeneficiario
            };
        });
    } catch (err) {
        const msgError = extractErrorFromResponse(err);
        console.error(msgError);
        throw msgError;
    }
}

const setBeneficiarioSession = (listaBeneficiarios, alreadyLoadedFromApi) => {
    let objSession = SessionService.getSession();

    if (alreadyLoadedFromApi) {
        SessionService.setSession({
            ...objSession,
            [beneficiarioValues.THIS]: listaBeneficiarios,
            alreadyLoadedBeneficiariosFromApi: alreadyLoadedFromApi
        });
    } else {
        SessionService.setSession({
            ...objSession,
            [beneficiarioValues.THIS]: listaBeneficiarios
        });
    }
};

export function beneficiariosReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case beneficiariosTypes.POPULATE_BENEFICIARIO: {
            let newListaBeneficiarios = action.payload;

            setBeneficiarioSession(newListaBeneficiarios, true);

            return { ...state, [beneficiarioValues.THIS]: newListaBeneficiarios };
        }
        case beneficiariosTypes.RESET: {
            return { ...INITIAL_STATE };
        }
        case beneficiariosTypes.ADICIONAR_BENEFICIARIO: {
            let novaListaBeneficiario = [
                ...state[beneficiarioValues.THIS],
                {
                    ...action.payload.beneficiario,
                    [beneficiarioValues.ID_BENEFICIARIO]: shortid.generate()
                }
            ];

            setBeneficiarioSession(novaListaBeneficiario);

            return {
                ...state,
                [beneficiarioValues.THIS]: novaListaBeneficiario
            };
        }
        case beneficiariosTypes.ATUALIZA_BENEFICIARIO: {
            setBeneficiarioSession(altualizaBeneficiario(state[beneficiarioValues.THIS], action.payload.beneficiario));
            return {
                ...state,
                [beneficiarioValues.THIS]: altualizaBeneficiario(
                    state[beneficiarioValues.THIS],
                    action.payload.beneficiario
                )
            };
        }
        case beneficiariosTypes.EXCLUIR_BENEFICIARIO: {
            const { idBeneficiario } = action.payload;

            // Filtra a listaBeneficiarios para expurgar o beneficiario a ser excluido
            let novaListaBeneficiarios = state.listaBeneficiarios.filter(
                (element) => element[beneficiarioValues.ID_BENEFICIARIO] !== idBeneficiario
            );

            setBeneficiarioSession(novaListaBeneficiarios);

            return {
                ...state,
                [beneficiarioValues.THIS]: novaListaBeneficiarios
            };
        }
        default:
            return state;
    }
}

/**
 * Actions
 */

export const Creators = {
    adicionaBeneficiario: (beneficiario) => ({
        type: beneficiariosTypes.ADICIONAR_BENEFICIARIO,
        payload: { beneficiario }
    }),

    atualizaBeneficiario: (beneficiario) => ({
        type: beneficiariosTypes.ATUALIZA_BENEFICIARIO,
        payload: { beneficiario }
    }),

    excluiBeneficiario: (idBeneficiario) => ({
        type: beneficiariosTypes.EXCLUIR_BENEFICIARIO,
        payload: { idBeneficiario }
    }),
    reset: () => ({
        type: beneficiariosTypes.RESET
    }),
    populateBeneficiarios: (beneficiariosFromApi) => ({
        type: beneficiariosTypes.POPULATE_BENEFICIARIO,
        payload: beneficiariosFromApi
    })
};
